enum SidePanelSizes {
   Small = 'Small',
   Medium = 'Medium',
   Large = 'Large',
   Larger = 'Larger',
}

enum SidePanelPlacements {
   Right = 'right',
   Left = 'left',
   Top = 'top',
   Bottom = 'bottom',
}

interface AtlSidePanelProps {
   show: boolean;
   size?: SidePanelSizes;
   placement?: SidePanelPlacements;
   backdrop?: boolean;
   bodyScrolling?: boolean;
   static?: boolean;
   resizable?: boolean;
   keyboard?: boolean;
   displayCloseButton?: boolean;
   label?: string;
}

export { SidePanelSizes, SidePanelPlacements };
export type { AtlSidePanelProps };
